export default __webpack_public_path__ + "static/media/Seashell wreath_primary.9290e042.jpg";